import { useEffect } from 'react';
import { isInIgnoredRouteTypes } from './isInIgnoredRouteTypes';
export function useScrollRestore({ location, ignoreForRouteTypes, prevLocation }) {
    useEffect(() => {
        if (ignoreForRouteTypes &&
            isInIgnoredRouteTypes({ location, routeTypes: ignoreForRouteTypes })) {
            return;
        }
        if (!prevLocation && location.hash !== '') {
            return;
        }
        if (prevLocation &&
            prevLocation.pathname === location.pathname &&
            prevLocation.search === location.search) {
            return;
        }
        window.scrollTo(0, 0);
    }, [ignoreForRouteTypes, location, prevLocation]);
}
//# sourceMappingURL=useScrollRestore.js.map